import { useState } from 'react'
import { router } from '@inertiajs/react'

// Optimistic heart toggle — the count updates instantly, Rails confirms after.
export default function HeartButton({ photo, size = 'md' }) {
  const [bursting, setBursting] = useState(false)
  const [optimistic, setOptimistic] = useState(null)

  const hearted = optimistic === null ? photo.heartedByMe : optimistic
  const count = photo.heartCount + (optimistic === null || optimistic === photo.heartedByMe ? 0 : optimistic ? 1 : -1)

  function toggle(event) {
    event.stopPropagation()
    const next = !hearted
    setOptimistic(next)

    if (next) {
      setBursting(true)
      setTimeout(() => setBursting(false), 450)
    }

    const options = { preserveScroll: true, preserveState: true, onFinish: () => setOptimistic(null) }

    if (next) {
      router.post(`/photos/${photo.id}/heart`, {}, options)
    } else {
      router.delete(`/photos/${photo.id}/heart`, options)
    }
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={hearted}
      aria-label={hearted ? 'Remove your heart' : 'Send a heart'}
      className={`inline-flex cursor-pointer items-center gap-1.5 rounded-full border-2 border-white bg-white/90 font-display font-bold shadow transition hover:bg-white ${
        size === 'lg' ? 'px-4 py-2 text-base' : 'px-3 py-1.5 text-sm'
      } ${hearted ? 'text-blush-500' : 'text-ink-soft'}`}
    >
      <span className={bursting ? 'animate-heart-burst' : ''} aria-hidden="true">
        {hearted ? '💖' : '🤍'}
      </span>
      {count > 0 && <span>{count}</span>}
    </button>
  )
}
